/**
 * Ryzup shop PDP — flavor gallery (main image + thumbnails + prev/next).
 */
(function () {
  function bindThumbLoad(thumb) {
    thumb.classList.add('is-loading');
    const img = thumb.querySelector('img');
    if (!img) return;

    const finish = () => {
      thumb.classList.remove('is-loading', 'buybox-gallery__thumb--skeleton');
      thumb.classList.add('is-loaded');
      img.classList.add('is-loaded');
    };

    if (img.complete && img.naturalWidth > 0) {
      finish();
      return;
    }

    img.addEventListener('load', finish, { once: true });
    img.addEventListener('error', finish, { once: true });
  }

  function bindGallery(root, slides) {
    const mainImg = root.querySelector('[data-ryzup-main-image]');
    const thumbsRoot = root.querySelector('[data-ryzup-gallery-thumbs]');
    const prevBtn = root.querySelector('[data-gallery-prev]');
    const nextBtn = root.querySelector('[data-gallery-next]');

    if (!mainImg || !thumbsRoot || !slides?.length) return null;

    thumbsRoot.innerHTML = slides
      .map((slide, index) => {
        const alt = slide.alt || '';
        return `
          <button
            type="button"
            class="buybox-gallery__thumb is-loading${index === 0 ? ' is-active' : ''}"
            data-hero-image="${slide.image}"
            data-hero-alt="${alt.replace(/"/g, '&quot;')}"
            aria-label="${alt.replace(/"/g, '&quot;')}"
            aria-selected="${index === 0 ? 'true' : 'false'}"
          >
            <img src="${slide.thumb}" alt="" loading="eager" decoding="async" width="80" height="80">
          </button>
        `;
      })
      .join('');

    const thumbs = [...thumbsRoot.querySelectorAll('.buybox-gallery__thumb')];
    thumbs.forEach(bindThumbLoad);

    const currentIndex = () => {
      const active = thumbs.findIndex((thumb) => thumb.classList.contains('is-active'));
      return active >= 0 ? active : 0;
    };

    const selectSlide = (index) => {
      if (!thumbs.length) return;
      const normalized = ((index % thumbs.length) + thumbs.length) % thumbs.length;
      const btn = thumbs[normalized];
      const src = btn.getAttribute('data-hero-image');
      const alt = btn.getAttribute('data-hero-alt');
      if (!src) return;

      mainImg.src = src;
      if (alt) mainImg.alt = alt;

      thumbs.forEach((thumb, i) => {
        const active = i === normalized;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => selectSlide(index));
    });

    if (slides.length <= 1) {
      prevBtn?.setAttribute('hidden', '');
      nextBtn?.setAttribute('hidden', '');
    } else {
      prevBtn?.removeAttribute('hidden');
      nextBtn?.removeAttribute('hidden');
    }

    selectSlide(0);

    return {
      selectSlide,
      onPrev: () => selectSlide(currentIndex() - 1),
      onNext: () => selectSlide(currentIndex() + 1),
    };
  }

  function createGallery(root) {
    let controller = null;
    let prevHandler = null;
    let nextHandler = null;
    const prevBtn = root.querySelector('[data-gallery-prev]');
    const nextBtn = root.querySelector('[data-gallery-next]');

    return {
      setSlides(slides) {
        if (prevHandler && prevBtn) prevBtn.removeEventListener('click', prevHandler);
        if (nextHandler && nextBtn) nextBtn.removeEventListener('click', nextHandler);

        controller = bindGallery(root, slides);

        if (controller && prevBtn && nextBtn) {
          prevHandler = () => controller.onPrev();
          nextHandler = () => controller.onNext();
          prevBtn.addEventListener('click', prevHandler);
          nextBtn.addEventListener('click', nextHandler);
        }
      },
    };
  }

  window.RyzupShopGallery = { createGallery };
})();
